export const MESSAGE = {
  DEFAULT_ERROR_MESSAGE: 'Error occured. Please try again later.',
};
